<template>
  <json-editor v-model="val" :height="height"></json-editor>
</template>

<script>
import JsonEditor from '@/components/JsonEditor'
export default {
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      }
    },
    height: {
      type: Number,
      default: 400
    }
  },
  components: {
    JsonEditor
  },
  mounted() {
    if(this.value) this.$emit("input", this.value);
  },
  computed: {
    val: {
      get() {
        return this.value || [];
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
}
</script>
